import * as _Prop from './prop';
export { _Prop as Prop };
export var Rerender = 'node.edit.rerender.time';